import React from 'react';
import { CircularProgress as Progress, Grid } from '@mui/material';

export const CircularProgress = (size, classes = {}) => (
  <Grid className={classes.loader}>
    <Progress color="inherit" size={size} />
  </Grid>
);
